module.exports = __webpack_public_path__ + "img/license_or_thred.2a18f98a.png";